import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

function sendPageView(pathname) {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', {
    page_title: document.title,
    page_location: window.location.href,
    page_path: pathname + window.location.search,
  });
}

function usePageTracking() {
  const location = useLocation();
  const lastTracked = useRef('');

  useEffect(() => {
    const currentPath = location.pathname + location.search;
    if (lastTracked.current === currentPath) return;
    sendPageView(location.pathname);
    lastTracked.current = currentPath;
  }, [location]);

  useEffect(() => {
    const handleClick = (e) => {
      if (typeof window.gtag !== 'function') return;
      const target = e.target.closest('[data-ga-click]');
      if (!target) return;
      window.gtag('event', 'click', {
        event_category: target.tagName === 'A' ? 'link' : 'button',
        event_label: target.getAttribute('data-ga-click'),
        page_path: location.pathname + location.search,
      });
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, [location.pathname, location.search]);
}

export { sendPageView };
export default usePageTracking;
